import dynamic from "next/dynamic";

export const KycGuideTips = dynamic(() => import("./KycGuideTips"), {
  ssr: false
});
